import React from 'react';
import { Navbar, Nav, NavDropdown, MenuItem, Image } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom'

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { setActiveLanguage } from 'react-localize-redux';

import { setLang } from './../../actions';
import { keys, includes } from 'lodash';

import browserLanguage from './../../stores/browserLanguage';

import './navbar.scss';

const bwGenericLogo = require('../../images/bwgeneric_logo.png');

const bwCoreLogo = require('../../images/bwcore_logo.png');
const bwMainLogo = require('../../images/bwmain_logo.png');
const bwPlusLogo = require('../../images/bwplus_logo.png');
const bwPremierLogo = require('../../images/bwpremier_logo.png');
const bwPremierCollectionLogo = require('../../images/bwpremiercollection_logo.png');
const bwSignatureCollectionLogo = require('../../images/bwsignaturecollection_logo.png');
const bwSureHotelCollectionLogo = require('../../images/bwsurehotelcollection_logo.png');
const whDistinctiveLogo = require('../../images/whdistinctive_logo.png');
const bwAidenLogo = require('../../images/bwaiden_logo.png');
const whCraftedLogo = require('../../images/whcrafted_logo.png');
const whEliteLogo = require('../../images/whelite_logo.png');

const supportedLangs = ['en', 'it', 'de', 'es', 'fr'];

const langMap = {
  en: {
    flag: require('../../images/flags/GB.png'),
    label: 'English'
  },
  it: {
    flag: require('../../images/flags/IT.png'),
    label: 'Italiano'
  },
  de: {
    flag: require('../../images/flags/DE.png'),
    label: 'Deutsch'
  },
  es: {
    flag: require('../../images/flags/ES.png'),
    label: 'Español'
  },
  fr: {
    flag: require('../../images/flags/FR.png'),
    label: 'Français'
  },
  zh: {
    flag: require('../../images/flags/CN.png'),
    label: '中文 (Chinese)'
  },
  ko: {
    flag: require('../../images/flags/KR.png'),
    label: '한국어 (Korean)'
  },
  ru: {
    flag: require('../../images/flags/RU.png'),
    label: 'русский (Russian)'
  },
  ar: {
    flag: require('../../images/flags/SA.png'),
    label: 'عربي (Arabic)'
  },
  ja: {
    flag: require('../../images/flags/JP.png'),
    label: '日本語 (Japanese)'
  },
  hi: {
    flag: require('../../images/flags/IN.png'),
    label: 'हिन्दी (Hindi)'
  },
  iw: {
    flag: require('../../images/flags/IL.png'),
    label: 'יהודי (Jewish)'
  },
  pt: {
    flag: require('../../images/flags/PT.png'),
    label: 'Português'
  },
  el: {
    flag: require('../../images/flags/GR.png'),
    label: 'Ελληνικά (Greek)'
  },
}

export class NavBar extends React.Component {

  constructor(props) {
    super(props);
    this.handleNavbarSelect = this.handleNavbarSelect.bind(this);
  }

  handleNavbarSelect(eventKey) {
    if(includes(supportedLangs, eventKey)) {
      this.props.actions.setActiveLanguage(eventKey);
      this.props.actions.setLang(this.props.token, this.props.context, eventKey);
    }
    else {
      this.props.actions.setActiveLanguage(this.props.currentLanguage);
      this.props.actions.setLang(this.props.token, this.props.context, this.props.currentLanguage);

      const destinationLang = (eventKey == 'other') ? browserLanguage : eventKey
      
      window.location = `https://translate.google.com/translate?sl=${this.props.currentLanguage}&tl=${destinationLang}&u=${encodeURIComponent(window.location.href)}`;
    }
  }

  render() {

    let logo;
    switch (this.props.template) {
      case 'BWCore':
        logo = bwCoreLogo
        break;
      case 'BWMain':
        logo = bwMainLogo
        break;
      case 'BWPlus':
        logo = bwPlusLogo
        break;
      case 'BWPremier':
        logo = bwPremierLogo
        break;
      case 'BWPremierCollection':
        logo = bwPremierCollectionLogo
        break;
      case 'BWSignatureCollection':
        logo = bwSignatureCollectionLogo
        break;
      case 'BWSureHotelCollection':
        logo = bwSureHotelCollectionLogo
        break;
      case 'WHDistinctive':
        logo = whDistinctiveLogo
        break;
      case 'BWAiden':
        logo = bwAidenLogo;
        break;
      case 'WHCrafted':
        logo = whCraftedLogo;
        break;
      case 'WHElite':
        logo = whEliteLogo;
        break;
      default:
        logo = bwGenericLogo
        break;
    }

    if(this.props.genericTemplate) logo = bwGenericLogo; // Override is genericTemplate prop is passed

    let currentLangFlag = langMap[this.props.currentLanguage].flag;

    const currentLang = <Image className="navbar-component__lang-flag-image" width={16} src={currentLangFlag} alt={this.props.currentLanguage} />

    return (
      <Navbar className="navbar-component" collapseOnSelect fixedTop={true} onSelect={this.handleNavbarSelect}>
        <Navbar.Header>
          <Navbar.Brand>
            {
              !!this.props.token
              ? <Link to={`/welcome/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`}><img className="nav-component__logo" src={logo} alt="Best Western" /></Link>
              : <Link to={'#'}><img className="nav-component__logo" src={logo} alt="Best Western" /></Link>
            }
          </Navbar.Brand>
          {
            !!this.props.token
            ? <Navbar.Toggle />
            : null
          }
        </Navbar.Header>
        {
          !!this.props.token
          ? <Navbar.Collapse>
              <ul className="nav navbar-nav">
                <li><NavLink activeClassName={'active'} to={`/welcome/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`}>{this.props.translate('shared.nav_bar.welcome')}</NavLink></li>
                <li><NavLink activeClassName={'active'} to={`/customize/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`}>{this.props.translate('shared.nav_bar.customize')}</NavLink></li>
                <li><NavLink activeClassName={'active'} to={`/restaurants/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`}>{this.props.translate('shared.nav_bar.restaurants')}</NavLink></li>
                <li><NavLink activeClassName={'active'} to={`/events/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`}>{this.props.translate('shared.nav_bar.events')}</NavLink></li>
                <li><NavLink activeClassName={'active'} to={`/news/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`}>{this.props.translate('shared.nav_bar.news')}</NavLink></li>
                <li><NavLink activeClassName={'active'} to={`/reach_us/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`}>{this.props.translate('shared.nav_bar.reach_us')}</NavLink></li>
              </ul>  
              <Nav>
                <NavDropdown title={currentLang} id="language-selection" className="navbar-component__lang-dropdown">
                  {
                    keys(langMap).map((key) => { 
                      return (
                        <MenuItem eventKey={key} key={key} translate="no"><Image className="navbar-component__lang-flag-image" width={16} src={langMap[key].flag} />&nbsp;{langMap[key].label}</MenuItem>
                      ) 
                    })
                  }
                  <MenuItem eventKey={'other'} translate="no"><Image className="navbar-component__lang-flag-image" width={16} src={null} />&nbsp;{this.props.translate('shared.nav_bar.more_languages')}</MenuItem>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          : null
        }
      </Navbar>
    );
  }
}

NavBar.displayName = 'SharedNav';
NavBar.propTypes = {};
NavBar.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    token: state.commons.token,
    context: state.commons.context,
    template: state.hotel.apiData.template
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setActiveLanguage: bindActionCreators(setActiveLanguage, dispatch),
      setLang: bindActionCreators(setLang, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);


// WEBPACK FOOTER //
// ./components/shared/NavBar.js